import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormUtility } from '../../../../../shared/utils';
import { PaypointService } from '../../../services/paypoint.service';

@Component({
  selector: 'kt-app-void-modal',
  templateUrl: './void-modal.component.html',
  styleUrls: ['./void-modal.component.scss'],
})
export class VoidModalComponent {
  voidForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<VoidModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private paypointService: PaypointService,
    private fb: FormBuilder,
    private formUtility: FormUtility,
  ) {
    this.voidForm = this.fb.group({
      reason: ['', [Validators.required]],
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.voidForm.markAllAsTouched();
    Object.values(this.voidForm.controls).forEach((c) => c.updateValueAndValidity());
    if (this.voidForm.invalid) return;

    this.paypointService
      .voidTransaction(this.data.transaction.payment_code, this.getFormControl('reason').value)
      .subscribe((response) => {
        this.dialogRef.close({ voided: response.data.voidStatus === 'Voided' });
      });
  }

  getFormControl(name: string): FormControl {
    return this.formUtility.getFormControl(this.voidForm, name);
  }
}
